import { BenefitsApplication } from './benefits-application';
import { UvbApplication } from './uvb-application';

export interface Case {
  exportQuelle: 'PAS' | 'PORTAL';
  exportAktionPAS: CaseAction;
  /**
   * Frontend ONLY - Appended metadata for NG-Frontend
   */

  portalStatus: CaseActionPortal;

  exportNrPAS?: number;

  exportNrPortal?: number;

  version: string;
  /**
   * Geschäftsfall-ID-PAS
   */
  gfIDPas: number | null;
  /**
   * Geschäftsfall-ID-Portal
   */
  gfIDPortal?: number;

  /**
   * Erstellungsdatum
   * ISO-8601: YYYY-MM-DD
   */
  gfErstelldatum: string;

  /**
   * Definiert ob das UI gesperrt wird oder nicht.
   * Markiert den Export status.
   */
  lockedForExport?: boolean;

  meldungKonzernwechselImportedNull: boolean;

  gfDaten: CaseData;
}

export interface  CaseData {
  /**
   * PAS: Vorbelegung laut Checkliste
   * Portal: nicht editierbar
   * ISO-8601: YYYY-MM-DD
   */
  austrittsdatum: string;

  /**
   * PAS: Vorbelegung laut Checkliste
   * Portal: nicht editierbar
   * Austrittsliste/Codes: "003 - Eivernehmliche Lösung"
   */
  austrittsgrundCode: AustrittsgrundCode;

  /**
   * PAS: Vorbelegung laut Checkliste
   * Portal: keine Anzeige, Steuerung Online-Formular
   */
  austrittsart: string;

  /**
   * PAS: Checkbox "Beitragsfreistellung initiieren" aus Checklsite
   */
  beitragsfreistellung?: boolean;

  /**
   * Konten
   */
  austrittsKonto: CaseAccount;
  weitereKonten?: CaseAccount[];

  /**
   * Stammdaten
   */
  datenAWB: CaseDataAWB;

  /**
   * Politiker
   */
  politiker?: Politikervertrag | null;

  /**
   * Anträge
   */
  datenLeistungsantrag?: BenefitsApplication;
  datenUvbFormular?: UvbApplication;
}

export enum AustrittsgrundCode {
  KUENDIGUNG_DURCH_DIENSTGEBER = 1,
  KUENDIGUNG_DURCH_DIENSTNEHMER = 2,
  EINVERNEHMLICHE_LOESUNG = 3,
  ZEITABLAUF_AUSNAHMEN = 4,
  VORZEITIGER_AUSTRITT = 5,
  FRISTLOSE_ENTLASSUNG = 6,
  PENSIONIERUNG = 16,
  BERUFSUNFAEHIGKEIT = 17,
  ENTLASSUNG_AUS_BUNDESBETR = 20,
  KDG_TEILZEITDN_IN_KARENZ = 21,
  UNBERECHTIGTER_VORZ_AUSTRITT = 22,
  KUENDIGUNG_DURCH_MASSEVERW = 25,
  DN_KUENDIGUNG_GEM_PAR_20C_AO = 26,
  DN_KUENDIGUNG_IN_PROBEZEIT = 30,
  DG_KUENDIGUNG_IN_PROBEZEIT = 31,
  ENDE_FR_DV_GEM_PAR_4_ASVG = 73,
  ENTHEBUNG_VON_GERICHTSPRAXIS = 74,
  DG_KUENDIGUNG_GEM_PAR_20C_AO = 75,
  AUST_MIT_DIENSTZEITANR = 78,
  AUST_UEBER_SOZIALKAP_VERPFL = 79,
  AUSTRITT_FRAU_VOR_60 = 88,
  BERUFSUNFAEHIGKEIT_S_H017 = 106,
  VORZEITIGE_ALTERSPENSION = 107,
  TOD_DES_DIENSTNEHMERS = 13,
  TOT_DN_IN_KARENZ_MSCHG_VKG = 27
}

export type CaseActions = CaseActionPortal | 'locked' | 'error_do_no_show';

export enum CaseActionPortal {
  edit = 'IN_BEARBEITUNG',
  error = 'FEHLERHAFT',
  complete = 'ABGESCHLOSSEN',
}

export enum CaseAction {
  pasClaimReported = 'Austritt gemeldet', // Keine Anzeige
  pasClaimVerified = 'Anspruch geprüft', // Keine Anzeige
  pasClaimReverted = 'Austritt zurückgesetzt', // Keine Anzeige
  pasClaimCorrection = 'AUSTRITT_KORRIGIERT', // Wird nie kommen
  pasClaimCanceled = 'AUSTRITT_STORNIERT', // Wird nie kommen

  pasClaimTransferred = 'UNTERLAGEN_ERMITTELT', // In Bearbeitung
  pasClaimError = 'UNTERLAGEN_URGIERT', // Fehler Zustand
  pasClaimComplete = 'UNTERLAGEN_GEPRUEFT' // Abgeschlossen Zustand
}

export type CaseAccount = {
  /**
   * PAS: Vorbelegung mit AWB-Nr.
   * Portal: nicht editierbar, Begünstigtenkonto-Nr.
   */
  beguenstigtenkontoNr: string;
  /**
   * PAS: Vorbelegung mit Vers.status
   * Portal: nicht editierbar
   */
  versicherungsstatus: string;

  modellArt?: string;
} | null;

export interface CaseBankAccount {
  iban: string;
  bic: string;
  lautendAuf?: string;
}

export interface Politikervertrag {
  frageNachErwerbseinkommen: boolean;
  erwerbseinkommenVorhanden: boolean | null;
}

export interface CaseDataAWB {
  kundenNr: string;
  betriebspensionskonto: string;
  geschlecht: Salutation;
  nachname: string;
  vorname: string;
  titel?: string;
  /**
   * ISO-8601: YYYY-MM-DD
   */
  geburtsdatum: string;
  svNr: string;
  familienStand: CaseDataAWBFamilienStand;
  /**
   * ISO-8601: YYYY-MM-DD
   */
  strNr: string;
  plz: string;
  ort: string;
  email?: string;
  telefonNr?: string;
}

export enum CaseDataAWBFamilienStand {
  undefined = 'UNDEFINED',
  single = 'SINGLE',
  married = 'MARRIED',
  divorced = 'DIVORCED',
  widowed = 'WIDOWED',
}

export enum CaseDocumentStatus {
  open = 'OFFEN',
  received = 'EINGELANGT',
  incomplete = 'UNVOLLSTAENDIG',
  complete = 'VOLLSTAENDIG',
}

export type Salutation = 'MANN' | 'FRAU' | 'DIVERS';

export type CaseDocument = {
  status: CaseDocumentStatus;
  portalUpload: boolean;
  dateiname: string;
  /**
   * Base64 DataUrl
   * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
   * data:[<mediatype>][;base64],<data>
   */
  data: string;
} | null;
